var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 11.9998L14.6998 15.8998C14.8831 16.0831 14.9748 16.3165 14.9748 16.5998C14.9748 16.8831 14.8831 17.1165 14.6998 17.2998C14.5165 17.4831 14.2831 17.5748 13.9998 17.5748C13.7165 17.5748 13.4831 17.4831 13.2998 17.2998L8.6998 12.6998C8.5998 12.5998 8.52897 12.4915 8.4873 12.3748C8.44564 12.2581 8.4248 12.1331 8.4248 11.9998C8.4248 11.8665 8.44564 11.7415 8.4873 11.6248C8.52897 11.5081 8.5998 11.3998 8.6998 11.2998L13.2998 6.6998C13.4831 6.51647 13.7165 6.4248 13.9998 6.4248C14.2831 6.4248 14.5165 6.51647 14.6998 6.6998C14.8831 6.88314 14.9748 7.11647 14.9748 7.3998C14.9748 7.68314 14.8831 7.91647 14.6998 8.0998L10.7998 11.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/left-chevron.4fd8b0d1b4d9fab6f49b5680ec39fea0.svg";
export { ForwardRef as ReactComponent };